<app-site-header></app-site-header>
<main class="page">
  <router-outlet></router-outlet>
</main>
<app-site-footer></app-site-footer>
<app-social-contact-rail></app-social-contact-rail>
<app-cart-feedback-toast></app-cart-feedback-toast>
<app-storefront-popup-ad *ngIf="deferHeavyChrome"></app-storefront-popup-ad>